import reactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

reactDOM.createRoot(document.getElementById("root")).render(<App />);
